import { Link } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';

const HOT_KEYWORDS = ['纪录片', 'Python', '播放器', '思维导图', '英语口语', '摄影'];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20teal%20background%20with%20flowing%20luminous%20curves%20and%20warm%20amber%20highlights%2C%20soft%20bokeh%20light%2C%20elegant%20editorial%20poster%20texture%2C%20deep%20atmospheric%20mood%2C%20high%20detail%2C%20wide%20composition&width=1920&height=800&seq=hero-bg-91&orientation=landscape"
          alt="免费91 平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/65 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
        <div className="w-full max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm mb-5">
            <i className="ri-sparkling-2-line text-accent-400"></i>
            免费 · 优质 · 持续更新
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl leading-tight text-background-50">
            免费91 · 优质免费资源分享平台
          </h1>
          <p className="mt-4 text-background-200 text-base md:text-lg leading-relaxed">
            汇聚免费视频、软件与教程，一站式搜索、分类浏览，快速找到你需要的免费内容。
          </p>

          <div className="mt-8 w-full max-w-2xl mx-auto">
            <SearchBar size="lg" />
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            <span className="text-sm text-background-300">热门搜索：</span>
            {HOT_KEYWORDS.map((word) => (
              <Link
                key={word}
                to={`/search?q=${encodeURIComponent(word)}`}
                className="px-3 py-1 rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-background-50 text-background-100 text-sm transition-colors cursor-pointer"
              >
                {word}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}